import React from 'react'

function DateTitolo(props) {
  const { from, to, yearBounds } = props
  const { last_year } = yearBounds

  if (!from || !to) {
    return (
      <div className="Main-dates">
        nel <strong>{last_year}</strong>
      </div>
    )
  } else if (from === to) {
    return (
      <div className="Main-dates">
        nel <strong>{from}</strong>
      </div>
    )
  } else {
    return (
      <div className="Main-dates">
        dal <strong>{from}</strong> al <strong>{to}</strong>
      </div>
    )
  }
}

export default DateTitolo



// WEBPACK FOOTER //
// ./src/main/DateTitolo.js